import React, { ReactElement, SVGProps } from "react";
import BaseIcon from "./BaseIcon";

const NoInsuranceIcon = (props: SVGProps<any>): ReactElement => {
  return (
    <BaseIcon {...props} viewBox="0 0 17 17">
      <path
        d="M14.546 2.025h-1.174c-1.697 0-3.292-.69-4.497-1.876A.47.47 0 0 0 8.524 0c-.13 0-.261.05-.351.15-1.205 1.185-2.8 1.875-4.497 1.875H2.502A.495.495 0 0 0 2 2.523V8.5c0 4.473 3.282 6.558 5.45 7.912.281.18.552.339.793.508.09.05.18.08.28.08s.192-.03.282-.08c.23-.159.492-.318.773-.498 2.178-1.354 5.47-3.44 5.47-7.922V2.523a.495.495 0 0 0-.502-.498"
        fill="#1FE0FF"
      />
      <path
        d="M15.05 2.523V8.5c0 4.482-3.293 6.568-5.47 7.922-.282.18-.543.339-.774.498-.09.05-.18.08-.28.08V0c.13 0 .26.05.35.15 1.205 1.185 2.8 1.875 4.497 1.875h1.174c.282 0 .502.22.502.498"
        fill="#F3D05F"
      />
      <path
        d="M8.524 4.017c-2.49 0-4.517 2.012-4.517 4.483s2.028 4.482 4.517 4.482S13.04 10.97 13.04 8.5s-2.027-4.483-4.516-4.483"
        fill="#fff"
      />
      <mask
        id="a"
        maskUnits="userSpaceOnUse"
        x="2"
        y="0"
        width="14"
        height="17"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.372 2.025h1.174c.281 0 .502.22.502.498V8.5c0 4.482-3.292 6.568-5.47 7.922l-.231.147q-.292.181-.542.351c-.09.05-.18.08-.281.08-.1 0-.19-.03-.281-.08a11 11 0 0 0-.526-.34l-.267-.168C5.282 15.058 2 12.972 2 8.5V2.523c0-.279.22-.498.502-.498h1.174c1.696 0 3.292-.69 4.497-1.876.09-.1.22-.149.35-.149.131 0 .262.05.352.15 1.205 1.185 2.8 1.875 4.497 1.875M4.008 8.5c0-2.47 2.027-4.482 4.516-4.482 2.49 0 4.517 2.012 4.517 4.482s-2.028 4.482-4.517 4.482S4.008 10.97 4.008 8.5"
          fill="#fff"
        />
      </mask>
      <g mask="url(#a)">
        <path d="M-3.771 0H8.648v21.675h-12.42z" fill="#E50000" />
      </g>
      <g clipPath="url(#b)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.5 8.208a.3.3 0 0 0 .298-.271l.156-1.712a.456.456 0 1 0-.908 0l.156 1.712a.3.3 0 0 0 .298.271"
          fill="#F61809"
        />
        <circle cx="8.5" cy="9.5" r=".5" fill="#E50000" />
      </g>
    </BaseIcon>
  );
};
export default NoInsuranceIcon;
